import { EraParser as r } from "./parsers/EraParser.js";
import { YearParser as e } from "./parsers/YearParser.js";
import { LocalWeekYearParser as o } from "./parsers/LocalWeekYearParser.js";
import { ISOWeekYearParser as m } from "./parsers/ISOWeekYearParser.js";
import { ExtendedYearParser as a } from "./parsers/ExtendedYearParser.js";
import { QuarterParser as t } from "./parsers/QuarterParser.js";
import { StandAloneQuarterParser as n } from "./parsers/StandAloneQuarterParser.js";
import { MonthParser as i } from "./parsers/MonthParser.js";
import { StandAloneMonthParser as s } from "./parsers/StandAloneMonthParser.js";
import { LocalWeekParser as p } from "./parsers/LocalWeekParser.js";
import { ISOWeekParser as P } from "./parsers/ISOWeekParser.js";
import { DateParser as f } from "./parsers/DateParser.js";
import { DayOfYearParser as w } from "./parsers/DayOfYearParser.js";
import { DayParser as d } from "./parsers/DayParser.js";
import { LocalDayParser as S } from "./parsers/LocalDayParser.js";
import { StandAloneLocalDayParser as c } from "./parsers/StandAloneLocalDayParser.js";
import { ISODayParser as M } from "./parsers/ISODayParser.js";
import { AMPMParser as l } from "./parsers/AMPMParser.js";
import { AMPMMidnightParser as u } from "./parsers/AMPMMidnightParser.js";
import { DayPeriodParser as D } from "./parsers/DayPeriodParser.js";
import { Hour1to12Parser as y } from "./parsers/Hour1to12Parser.js";
import { Hour0to23Parser as O } from "./parsers/Hour0to23Parser.js";
import { Hour0To11Parser as T } from "./parsers/Hour0To11Parser.js";
import { Hour1To24Parser as I } from "./parsers/Hour1To24Parser.js";
import { MinuteParser as Y } from "./parsers/MinuteParser.js";
import { SecondParser as h } from "./parsers/SecondParser.js";
import { FractionOfSecondParser as k } from "./parsers/FractionOfSecondParser.js";
import { ISOTimezoneWithZParser as A } from "./parsers/ISOTimezoneWithZParser.js";
import { ISOTimezoneParser as H } from "./parsers/ISOTimezoneParser.js";
import { TimestampSecondsParser as L } from "./parsers/TimestampSecondsParser.js";
import { TimestampMillisecondsParser as W } from "./parsers/TimestampMillisecondsParser.js";
const sr = {
  G: new r(),
  y: new e(),
  Y: new o(),
  R: new m(),
  u: new a(),
  Q: new t(),
  q: new n(),
  M: new i(),
  L: new s(),
  w: new p(),
  I: new P(),
  d: new f(),
  D: new w(),
  E: new d(),
  e: new S(),
  c: new c(),
  i: new M(),
  a: new l(),
  b: new u(),
  B: new D(),
  h: new y(),
  H: new O(),
  K: new T(),
  k: new I(),
  m: new Y(),
  s: new h(),
  S: new k(),
  X: new A(),
  x: new H(),
  t: new L(),
  T: new W()
};
export {
  sr as parsers
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/parse/_lib/parsers.js
// module id = 1363
// module chunks = 41